//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 24/10/2025
// Version       : 1
// Description   : Editar tipos de vehículos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Stack,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Grid from "@mui/material/Grid";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function EditarTipo(props) {
  const [datosTipo, setDatosTipo] = useState({
    id: null,
    nombre: props.tipo.nombre,
    estado: 1,
    requiere_chofer: 0,
    es_t1: 0,
    es_grua: 0,
  });

  // Notification
  const [openSnack, setOpenSnack] = useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("success"); // "success" | "error"

  // Deshabilitar boton al guardar
  const [disBtn, setDisBtn] = useState(false);

  // Datos iniciales
  useEffect(() => {
    if (props.tipo) {
      setDatosTipo({
        estado: props.tipo.estado ?? 1,
        requiere_chofer: props.tipo.requiere_chofer ?? 0,
        es_t1: props.tipo.es_t1 ?? 0,
        es_grua: props.tipo.es_grua ?? 0
      });
    }
  }, [props.tipo]);

  // Función GUARDAR (EDITAR)
  const guardarEditar = async (e) => {
    e.preventDefault();
    setDisBtn(true);

    try {
      const res = await fetch(`${UrlApi}/tipos_vehiculos2/${props.tipo.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: datosTipo.estado ?? 1,
          requiere_chofer: datosTipo.requiere_chofer,
          es_t1: datosTipo.es_t1,
          es_grua: datosTipo.es_grua,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        setSeverity("success");
        setColorMensaje("#D4EFDF");
        setMensaje("El tipo se actualizó correctamente.");
      } else if (res.status === 409) {
        setSeverity("error");
        setColorMensaje("#F1948A");
        setMensaje(data.message || "Conflicto: el tipo ya existe.");
        setDisBtn(false);
      } else {
        setSeverity("error");
        setColorMensaje("#F1948A");
        setMensaje(data.error || "Error al actualizar el tipo.");
        setDisBtn(false);
      }
    } catch (err) {
      setSeverity("error");
      setColorMensaje("#F1948A");
      setMensaje("Error de red o servidor.");
      setDisBtn(false);
    } finally {
      setOpenSnack(true);
    }
  };

  // Manejo de los checkboxes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setDatosTipo((prev) => ({
      ...prev,
      [name]: checked ? 1 : 0,
    }));
  };

  // Cierre de la notificación
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);

    if (severity === "success") {
      if (typeof props.onTipoGuardado === "function") props.onTipoGuardado();
      if (typeof props.handleCloseEditarTipo === "function")
        props.handleCloseEditarTipo();
      setDisBtn(false);
    }
    // Si fue error, el modal queda abierto y el botón ya fue reactivado cuando correspondía
  };

  return (
    <>
      <Box>
        <DialogTitle
          sx={{
            p: 0,
            mt: 0,
            mb: 3,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{
              background: "linear-gradient(135deg, #2B76A6 0%, #094d77ff 100%)",
              borderBottomRightRadius: "12px",
              padding: "8px 18px",
            }}
          >
            {`Editar Tipo de Vehículo${
              props.tipo.nombre ? " — " + props.tipo.nombre : ""
            }`}
          </Typography>
        </DialogTitle>

        <DialogContent>
          <form onSubmit={guardarEditar}>
            <Grid container spacing={2} mt={0.5}>
              {/* CHECKBOXES */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(250,250,252,0.95))",
                    border: "1px solid rgba(25,118,210,0.12)",
                    borderRadius: 2,
                    p: 2,
                    boxShadow: "0 6px 18px rgba(15, 40, 60, 0.03)",
                  }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={2}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: "#0f4c81",
                          mb: { xs: 1, md: 0 },
                        }}
                      >
                        Opciones
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={10}>
                      <Grid container spacing={1} alignItems="center">
                        {/* Requiere Chofer */}
                        <Grid item xs={6} sm={4} md={2.5}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={datosTipo.requiere_chofer === 1}
                                onChange={handleCheckboxChange}
                                name="requiere_chofer"
                                size="small"
                                sx={{
                                  transform: "scale(1.15)",
                                  "& .MuiSvgIcon-root": { fontSize: 20 },
                                }}
                              />
                            }
                            label={
                              <Typography sx={{ fontWeight: 600 }}>
                                Requiere Chofer
                              </Typography>
                            }
                            labelPlacement="end"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          />
                        </Grid>

                        {/* Es T1 */}
                        <Grid item xs={6} sm={4} md={2.5}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={datosTipo.es_t1 === 1}
                                onChange={handleCheckboxChange}
                                name="es_t1"
                                size="small"
                                sx={{
                                  transform: "scale(1.15)",
                                  "& .MuiSvgIcon-root": { fontSize: 20 },
                                }}
                              />
                            }
                            label={
                              <Typography sx={{ fontWeight: 600 }}>
                                Es T1
                              </Typography>
                            }
                            labelPlacement="end"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          />
                        </Grid>

                        {/* Es Grúa */}
                        <Grid item xs={6} sm={4} md={2.5}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={datosTipo.es_grua === 1}
                                onChange={handleCheckboxChange}
                                name="es_grua"
                                size="small"
                                sx={{
                                  transform: "scale(1.15)",
                                  "& .MuiSvgIcon-root": { fontSize: 20 },
                                }}
                              />
                            }
                            label={
                              <Typography sx={{ fontWeight: 600 }}>
                                Es Grúa
                              </Typography>
                            }
                            labelPlacement="end"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* BOTONES */}
              <Grid item xs={12} mt={3}>
                <Box display="flex" justifyContent="space-between">
                  <Button
                    variant="contained"
                    color="error"
                    onClick={props.handleCloseEditarTipo}
                    sx={{
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Volver
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={disBtn}
                    sx={{
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Guardar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Box>

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default EditarTipo;
